import AnchorComponent from "../components/anchor";
import ButtonComponent from "../components/button";
import DivComponent from "../components/div";
import ParagraphComponent from "../components/paragraph";
import {setCountCartHeader} from "../init-cart";
import {setAddCart} from "../require/set-add-cart";
import {RenderPosition, render} from "../utils/render";

export default class CommerceControllerLikeMP {
  constructor({container, className, itemId = ``, count = 0, deliveryDate, deliveryText, deliveryNote}) {
    this._container = container;
    this._className = className;
    this._itemId = itemId;
    this._count = count;
    this._deliveryDate = deliveryDate;
    this._deliveryText = deliveryText;
    this._deliveryNote = deliveryNote;

    this._onCartButtonClickHandler = this._onCartButtonClickHandler.bind(this);
  }

  render() {
    if (!this._itemId) {
      return;
    }

    this._commerceWrap = new DivComponent(`items__commerceWrap`);
    render(this._container, this._commerceWrap.getElement(), RenderPosition.BEFOREEND);
    this._setActiveContainer();

    this._renderCartButton(this._commerceWrap.getElement());
    this._renderCartLink(this._commerceWrap.getElement());
    this._renderDeliveryNote(this._container);
  }

  _renderCartButton(container) {
    const button = new ButtonComponent({
      className: `items__addToCartButton`,
      title: this._deliveryText,
      prompt: `Добавить в корзину`,
    });

    button.setClickHandler(this._onCartButtonClickHandler);

    render(container, button.getElement(), RenderPosition.BEFOREEND);
  }

  _renderCartLink(container) {
    const link = new AnchorComponent({
      className: `items__cartLink`,
      title: `В корзине`,
      link: `/cart`,
      prompt: `Перейти в корзину`
    });

    render(container, link.getElement(), RenderPosition.BEFOREEND);
  }

  _renderDeliveryNote(container) {
    if (!this._deliveryNote) {
      return;
    }

    const text = new ParagraphComponent({
      className: `${this._className}__itemDeliveryNote`,
      text: this._deliveryNote,
    });

    render(container, text.getElement(), RenderPosition.BEFOREEND);
  }

  _setActiveContainer() {
    this._commerceWrap.getElement().dataset.inCart = this._count > 0;
  }

  _addCart(count) {
    setAddCart(this._itemId, (response) => {
      setCountCartHeader(response.cart_count);
      this._count = count;
      this._setActiveContainer();
    });
  }

  _onCartButtonClickHandler() {
    this._addCart(1);
  }
}

